import React, { useState, useEffect } from "react";
import { Modal, FormInput, FormTextarea, Button } from "@/components/ui";
import { Calendar } from "lucide-react";

export const UpdateAppointmentForm = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData && isOpen) {
      setFormData({
        appointmentDate: initialData.appointmentDate ? new Date(initialData.appointmentDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
        notes: ""
      });
    }
  }, [initialData, isOpen]);

  if (!isOpen || !initialData) return null;

  const fullName = initialData?.customerName || `${initialData?.firstName || ""} ${initialData?.lastName || ""}`.trim() || "No Name";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dataToSubmit = { ...formData };
      if (dataToSubmit.notes) {
        dataToSubmit.appointmentNote = dataToSubmit.notes;
        dataToSubmit.activityNote = dataToSubmit.notes;
      }
      await onSubmit(initialData._id, dataToSubmit);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Reschedule Appointment`}
      size="sm"
    >
      <div className="space-y-5">
        <div className="flex items-center gap-3 pb-3 border-b border-slate-100">
          <div className="w-10 h-10 rounded-full bg-brand-blue/10 flex items-center justify-center font-bold text-brand-blue uppercase">
            {fullName.charAt(0)}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold text-brand-dark truncate">{fullName}</div>
            <div className="text-[10px] text-slate-400 font-medium">
              Updating Appointment Details
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-4">
            <div className="p-4 bg-orange-50 rounded-xl border border-orange-100 flex items-start gap-3">
              <div className="p-2 bg-orange-100 text-orange-600 rounded-lg">
                <Calendar size={20} />
              </div>
              <div>
                <div className="text-sm font-bold text-orange-800">Reschedule Appointment</div>
                <div className="text-xs text-orange-600 mt-0.5">Select a date for the site visit or meeting.</div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <FormInput
                label="Appointment Date *"
                type="date"
                value={formData.appointmentDate || ""}
                onChange={e => setFormData({ ...formData, appointmentDate: e.target.value })}
                min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>
            
            <FormTextarea
              label="Transition Notes / Activity Comment"
              placeholder="What happened? Why the change?"
              value={formData.notes || ""}
              onChange={e => setFormData({ ...formData, notes: e.target.value })}
              rows={3}
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button
              type="submit"
              className="flex-1"
              loading={loading}
              variant="orange"
            >
              Update Appointment
            </Button>
            <Button variant="secondary" onClick={onClose} className="px-6">Cancel</Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
